export default __webpack_public_path__ + "static/media/life.168afd81.jpeg";